<template>
  <div class="card-list-view">
    <HeaderTab />
    <PcSearch v-if="false" class=" d-none d-sm-block" />
    <SpSearch v-if="false" class="d-block d-sm-none" />
    <AuthList v-if="user" />

    <SpLP class="d-flex d-md-none" />
    <v-row class="card-row">
      <v-col
        class="card-col"
        cols="6"
        sm="6"
        md="4"
        v-for="(product, index) in storeProduct"
        :key="index"
      >
        <Card
          :id="product.id"
          :src="product.url"
          :course="product.course"
          :title="product.productName"
          :tags="product.productImages"
          :explaination="product.productShortEx"
        />
      </v-col>
    </v-row>
    <PcLP class="d-none d-md-flex" />
  </div>
</template>

<script>
import HeaderTab from "@/components/molecules/HeaderTab/Component.vue"
import Card from "@/components/atoms/Card/Component.vue"
import AuthList from "@/components/molecules/Admin/AuthList.vue"

export default {
  name: "CardListView",
  components: {
    Card,
    HeaderTab,
    AuthList,
    PcSearch: () => import("@/components/molecules/SearchBar/PcComponent.vue"),
    SpSearch: () => import("@/components/molecules/SearchBar/SpComponent.vue"),
    PcLP: () => import("@/components/molecules/LP/PcComponent.vue"),
    SpLP: () => import("@/components/molecules/LP/SpComponent.vue"),
  },
  data: () => ({
    products: [],
  }),
  computed: {
    storeProduct() {
      return this.$store.state.products
    },
    user() {
      return !!this.$store.getters.user.isAuth
    },
  },
  created() {
    this.$store.commit("resetNumberOfCards")
    this.$store.commit("resetProducts")
    if (this.$store.state.selectIndex === 0) {
      this.$store.dispatch("fetchProducts")
    } else {
      this.$store.dispatch(
        "fetchSpecificProducts",
        this.$store.state.selectIndex - 1
      )
    }
    window.addEventListener("scroll", this.scroll)
  },
  destroyed() {
    window.removeEventListener("scroll", this.scroll)
  },
  methods: {
    scroll: function() {
      if (this.$store.state.products.length < this.$store.state.NumberOfCards) {
        return 0
      }
      if (
        window.scrollY >
        document.documentElement.offsetHeight - window.innerHeight - 500
      ) {
        let isAllCourse = true
        let selectedCourse = 0
        if (this.$store.state.selectIndex === 0) {
          isAllCourse = true
        } else {
          selectedCourse = this.$store.state.selectIndex
          isAllCourse = false
        }

        if (isAllCourse) {
          this.$store.dispatch("fetchNextProducts")
          this.$store.dispatch("increaseNumberOfCards")
        } else {
          this.$store.dispatch("fetchNextSpecificProducts", selectedCourse - 1)
          this.$store.dispatch("increaseNumberOfCards")
        }
      }
    },
  },
}
</script>

<style lang="scss">
.card-list-view {
  .card-row {
    margin: 0 auto;
    max-width: none;
    width: 77%;
  }
}

@media screen and (min-width: 1600px) {
  .card-list-view {
    .card-col {
      flex: 0 0 25%;
      max-width: 25%;
    }
  }
}

@media screen and (max-width: 960px) {
  .card-list-view {
    .card-col {
      flex: 0 0 50%;
      max-width: 50%;
      width: 100%;
    }
    .card-row {
      width: 97.5%;
    }
    .col-md-4,
    .col-sm-6,
    .col-6 {
      padding: 6px;
    }
  }
}
@media screen and (max-width: 640px) {
}
</style>
